export default async function cargarjsonOrtofotos() {
  try {
    const response = await fetch('./ortofotos.json');

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error al cargar el JSON de ortofotos:', error);
    return null;
  }
}